import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const NotFound = () => {
    const { loading, isAuthenticated, user } = useAuth();

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '18px',
                color: '#bc965e'
            }}>
                Loading...
            </div>
        );
    }

    // If user is authenticated, redirect to their appropriate dashboard
    if (isAuthenticated) {
        if (user?.role === 'Admin') {
            return <Navigate to="/admin/dashboard" replace />;
        } else {
            return <Navigate to="/" replace />;
        }
    }

    // If user is not authenticated, redirect to login
    return <Navigate to="/login" replace />;
};

export default NotFound;